@if (label()) {
  <app-label [htmlFor]="htmlFor()" [value]="label()"></app-label>
}
<textarea
  [rows]="rows()"
  (input)="onInput($event)"
  class="focusable {{ textareaStyleClass() }} relative"
  [value]="value()"
  [placeholder]="placeholder()"
></textarea>
<div class="flex items-center justify-between">
  <app-validation-output [value]="errorMessage()" />
  @if (maxLength()) {
    <div class="text-muted text-xs">
      {{ value()?.length ?? 0 }} / {{ maxLength() }}
    </div>
  }
</div>
